module.exports = __webpack_public_path__ + "static/img/sec5-cont01-main@t.e79b91c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec5-cont01-main@t.png
// module id = 57n0
// module chunks = 0